import keyBy from 'lodash/keyBy';

export const DEMO_USER_ID = 'demo';

export const demoImages = [
    {
        name: 'Amazing-Harley-Davidson-1600',
        previewSrc: '/img/demo/000 Amazing-Harley-Davidson-1600-dc-small.png',
        poppedSrc: '/img/demo/000 Amazing-Harley-Davidson-1600-dc-popped-a3-s2.png',
        src: '/img/demo/000 Amazing-Harley-Davidson-1600-dc-orig.png',
        width: 1600,
        height: 1000,
    },
    {
        name: 'flowers',
        previewSrc: '/img/demo/005 flowers-small.jpeg',
        poppedSrc: '/img/demo/005 flowers-popped-a1-s5.jpeg',
        src: '/img/demo/005 flowers-orig.jpeg',
        width: 2448,
        height: 3264,
    },
    {
        name: 'skechers outfit 2',
        previewSrc: '/img/demo/010 skechers outfit 2-small.png',
        poppedSrc: '/img/demo/010 skechers outfit 2-popped-a1-s4.png',
        src: '/img/demo/010 skechers outfit 2-orig.png',
        width: 1300,
        height: 1151,
    },
    {
        name: 'lebron',
        previewSrc: '/img/demo/020 lebron-small.jpeg',
        poppedSrc: '/img/demo/020 lebron-popped-a2-s4.jpeg',
        src: '/img/demo/020 lebron-orig.jpeg',
        width: 1200,
        height: 802,
    },
    {
        name: 'statue',
        previewSrc: '/img/demo/040 statue-small.jpeg',
        poppedSrc: '/img/demo/040 statue-popped-a1-s5.jpeg',
        src: '/img/demo/040 statue-orig.jpeg',
        width: 2448,
        height: 3264,
    },
    {
        name: 'strand house',
        previewSrc: '/img/demo/050 strand house-dc-small-e.jpeg',
        poppedSrc: '/img/demo/050 strand house-popped-a1-s5-e.jpeg',
        src: '/img/demo/050 strand house-dc-orig-e.jpeg',
        width: 2000,
        height: 1334,
    },
    {
        name: 'tajmahal-cover',
        previewSrc: '/img/demo/055 tajmahal-cover-dc-small-e.jpeg',
        poppedSrc: '/img/demo/055 tajmahal-cover-dc-popped-a1-s4-e.jpeg',
        src: '/img/demo/055 tajmahal-cover-dc-orig-e.jpeg',
        width: 1500,
        height: 578,
    },
    {
        name: 'fat boy',
        previewSrc: '/img/demo/056 fat boy-dc-small.jpeg',
        poppedSrc: '/img/demo/056 fat boy-dc-popped-a2-s5.jpeg',
        src: '/img/demo/056 fat boy-dc-orig.jpeg',
        width: 3495,
        height: 2621,
    },
    {
        name: 'stormy daniels',
        previewSrc: '/img/demo/060 stormy daniels-dc-small.jpeg',
        poppedSrc: '/img/demo/060 stormy daniels-dc-popped-a1-s5-e.jpeg',
        src: '/img/demo/060 stormy daniels-dc-orig.jpeg',
        width: 701,
        height: 1000,
    },
    {
        name: 'alek_wek_13_orig_im',
        previewSrc: '/img/demo/062 alek_wek_13_orig_im-dc-small.png',
        poppedSrc: '/img/demo/062 alek_wek_13_orig_im-dc-popped-a2-s4.png',
        src: '/img/demo/062 alek_wek_13_orig_im-dc-orig.png',
        width: 800,
        height: 871,
    },
    {
        name: 'wedding dress-orig',
        previewSrc: '/img/demo/063 wedding dress-small-dc-small.png',
        poppedSrc: '/img/demo/063 wedding dress-orig-dc-popped-a1-s3.png',
        src: '/img/demo/063 wedding dress-orig-dc-orig.png',
        width: 1200,
        height: 846,
    },
    {
        name: 'Sarandon_0',
        previewSrc: '/img/demo/070 Sarandon_0-dc-small.png',
        poppedSrc: '/img/demo/070 Sarandon_0-dc-popped-a1-s5.png',
        src: '/img/demo/070 Sarandon_0-dc-orig.png',
        width: 1046,
        height: 1336,
    },
    {
        name: 'carmen at beach',
        previewSrc: '/img/demo/075 carmen at beach-dc-small-e.jpeg',
        poppedSrc: '/img/demo/075 carmen at beach-dc-popped-a1-s4-e.jpeg',
        src: '/img/demo/075 carmen at beach-dc-orig-e.jpeg',
        width: 1600,
        height: 2416,
    },
    {
        name: 'baywatch',
        previewSrc: '/img/demo/080 baywatch-dc-small-e.jpeg',
        poppedSrc: '/img/demo/080 baywatch-dc-popped-a1-s4-e.jpeg',
        src: '/img/demo/080 baywatch-dc-orig-e.jpeg',
        width: 1280,
        height: 720,
    },
    {
        name: 'hound1',
        previewSrc: '/img/demo/085 hound1-dc-small.jpeg',
        poppedSrc: '/img/demo/085 hound1-dc-popped-a3-s4.jpeg',
        src: '/img/demo/085 hound1-dc-orig.jpeg',
        width: 1920,
        height: 1080,
    },
    {
        name: 'whitewalker1',
        previewSrc: '/img/demo/090 whitewalker1-dc-small.jpeg',
        poppedSrc: '/img/demo/090 whitewalker1-dc-popped-a3-s5.jpeg',
        src: '/img/demo/090 whitewalker1-dc-orig.jpeg',
        width: 1920,
        height: 1080,
    },
    {
        name: 'farmland',
        previewSrc: '/img/demo/095 farmland-dc-small-e.png',
        poppedSrc: '/img/demo/095 farmland-dc-popped-a4-s4.png',
        src: '/img/demo/095 farmland-dc-orig-e.png',
        width: 1800,
        height: 1350,
    },
    {
        name: 'grapes',
        previewSrc: '/img/demo/100 grapes-small.jpeg',
        poppedSrc: '/img/demo/100 grapes-popped-a1-s5.jpeg',
        src: '/img/demo/100 grapes-orig.jpeg',
        width: 2448,
        height: 3264,
    },
    {
        name: 'chichenitza',
        previewSrc: '/img/demo/105 chichenitza-dc-small.png',
        poppedSrc: '/img/demo/105 chichenitza-dc-popped-a2-s4.png',
        src: '/img/demo/105 chichenitza-dc-orig.png',
        width: 1500,
        height: 1125,
    },
    {
        name: 'glomerulus-orig',
        previewSrc: '/img/demo/110 glomerulus-small-dc-small-e.png',
        poppedSrc: '/img/demo/110 glomerulus-orig-dc-popped-a4-s1-e.png',
        src: '/img/demo/110 glomerulus-orig-dc-orig-e.png',
        width: 1000,
        height: 1000,
    },
    {
        name: 'clear frog',
        previewSrc: '/img/demo/115 clear frog-dc-small.jpeg',
        poppedSrc: '/img/demo/115 clear frog-dc-popped-a1-s5.jpeg',
        src: '/img/demo/115 clear frog-dc-orig.jpeg',
        width: 800,
        height: 585,
    },
    {
        name: 'U.S._Navy_Sailors_swim_underwater.',
        previewSrc: '/img/demo/117 U.S._Navy_Sailors_swim_underwater.-dc-small.png',
        poppedSrc: '/img/demo/117 U.S._Navy_Sailors_swim_underwater.-dc-popped-a1-s4.png',
        src: '/img/demo/117 U.S._Navy_Sailors_swim_underwater.-dc-orig.png',
        width: 3000,
        height: 2045,
    },
    {
        name: 'cool armored ships',
        previewSrc: '/img/demo/119 cool armored ships-dc-small.png',
        poppedSrc: '/img/demo/119 cool armored ships-dc-popped-a3-s3.png',
        src: '/img/demo/119 cool armored ships-dc-orig.png',
        width: 1091,
        height: 843,
    },
    {
        name: 'tank',
        previewSrc: '/img/demo/230 tank-dc-small.png',
        poppedSrc: '/img/demo/230 tank-dc-popped-a2-s4.png',
        src: '/img/demo/230 tank-dc-orig.png',
        width: 1280,
        height: 852,
    },
    {
        name: 'night vision-orig',
        previewSrc: '/img/demo/235 night vision-small-dc-small.png',
        poppedSrc: '/img/demo/235 night vision-orig-dc-popped-a2-s5.png',
        src: '/img/demo/235 night vision-orig-dc-orig.png',
        width: 900,
        height: 600,
    },
    {
        name: 'car',
        previewSrc: '/img/demo/237 car-small.png',
        poppedSrc: '/img/demo/237 car-popped-a2-s4.png',
        src: '/img/demo/237 car-orig.png',
        width: 1600,
        height: 1200,
    },
    {
        name: 'nude model',
        previewSrc: '/img/demo/300 nude model-small-e.png',
        poppedSrc: '/img/demo/300 nude model-popped-a1-s4-e.png',
        src: '/img/demo/300 nude model-orig-e.png',
        width: 2365,
        height: 1592,
    }
];

demoImages.forEach((img, idx) => {
    img.status = 'DEMO';
    img.id = idx + 1;
    img.userId = DEMO_USER_ID;
    img.fileName = img.name + '.png';
});

export const demoImagesById = keyBy(demoImages, 'id');



// WEBPACK FOOTER //
// ./src/demoData.js